<script setup lang="ts">
import { usePost } from "@/hooks";
import PageRender from "@/components/components/PageRender.vue";
import { useRoute } from "vue-router";
import type { ShowFormParameters } from "@/global";
import { computed, watch } from "vue";
import { setToken, showLoading } from "@/utils";

interface ShowFormResult {
  token: string;
  openParameters: ShowFormParameters;
}
const route = useRoute();
const ins = showLoading("");
const { data } = usePost<ShowFormResult | undefined>(
  "MpStartup/ShowForm",
  () => undefined,
  computed(() => ({
    args: decodeURIComponent(<string>route.query.args),
    flag: import.meta.env.VITE_APP_FLAG,
  }))
);

watch(data, (data) => {
  if (!data) return;
  ins.hide();
  setToken(data.token);
});
</script>
<template>
  <div v-if="data?.openParameters" style="height: 100%">
    <PageRender :show-params="data?.openParameters" />
  </div>
</template>
